import React, { useEffect, useState } from "react";
import baseUrl from "../../../api/baseUrl";
import AddDrugs from "./AddDrugs";
import { toast } from "react-toastify";
import DrugsTr from "./DrugsTr";
import AddIcon from "@mui/icons-material/Add";
import MedicationIcon from "@mui/icons-material/Medication";
import SearchIcon from "@mui/icons-material/Search";

function Drugs() {
  const [diagnoseOpen, setdiagnoseOpen] = useState(false);
  const [data, setData] = useState([]);
  const [id, setid] = useState({});
  const [search, setSearch] = useState("");

  const openModel = () => {
    setdiagnoseOpen(!diagnoseOpen);
  };

  const editBtn = (e: any) => {
    setdiagnoseOpen(!diagnoseOpen);
    setid(e);
  };

  const close = (e: any) => {
    setdiagnoseOpen(e);
    getData();
    setid("");
  };

  const getData = async () => {
    baseUrl
      .get("/client/prescription/prescription/findAllPrescription")
      .then((response) => setData(response.data.data))
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch data. Please try again.");
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const filteredData = data.filter((item: any) =>
    item?.drugs?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>

      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4 mt-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Search */}
          <div className="relative flex-1 max-w-md">
            <SearchIcon
              className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500"
              sx={{ fontSize: 20 }}
            />
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search drugs..."
              className="w-full pl-12 pr-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>

          <div className="flex items-center gap-4">
            {/* Count Badge */}
            <div className="flex items-center gap-2 px-4 py-2 bg-emerald-50 dark:bg-emerald-900/40 rounded-xl">
              <MedicationIcon className="text-emerald-500 dark:text-emerald-400" sx={{ fontSize: 20 }} />
              <span className="font-bold text-emerald-600 dark:text-emerald-400">{data.length}</span>
              <span className="text-slate-500 dark:text-slate-400 text-sm">Drugs</span>
            </div>

            {/* Add Button */}
            <button
              onClick={() => openModel()}
              className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-xl hover:shadow-lg hover:shadow-primary/20 transition-all font-medium"
            >
              <AddIcon sx={{ fontSize: 20 }} />
              Add Drug
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden mt-4">
        {/* Mobile Cards */}
        <div className="md:hidden p-4 space-y-3">
          {filteredData.length === 0 ? (
            <div className="text-center py-12 text-slate-400 dark:text-slate-500">
              <MedicationIcon sx={{ fontSize: 48 }} className="mb-2" />
              <p>No drugs found</p>
            </div>
          ) : (
            filteredData.map((item: any, i: number) => (
              <DrugsTr
                key={i}
                item={item}
                i={i}
                editBtn={editBtn}
                data={data}
                setData={setData}
                isMobile
              />
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50/80 dark:bg-slate-700/50">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  No
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Drug Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Dose
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-6 py-12 text-center text-slate-400 dark:text-slate-500">
                    <MedicationIcon sx={{ fontSize: 48 }} className="mb-2" />
                    <p>No drugs found</p>
                  </td>
                </tr>
              ) : (
                filteredData.map((item: any, i: number) => (
                  <DrugsTr
                    key={i}
                    item={item}
                    i={i}
                    editBtn={editBtn}
                    data={data}
                    setData={setData}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {diagnoseOpen && <AddDrugs close={close} id={id} />}
    </>
  );
}

export default Drugs;
